<template>
  <section>
    <back-button to="/"/>
    <h1>{{ $t('requestExchange.title') }}</h1>
    <panel class="req-x-panel">
      <div class="balance">
        <div class="message">
          <div v-if="isFetching" class="loading">{{ $t('requestExchange.loading') }}</div>
          <div v-if="isFetched && isError" class="error">{{ $t('requestExchange.error') }}</div>
          <div v-if="isFetched && !isError">{{ $t('requestExchange.currentBalanceIs') }} <strong>{{ numberFormat(jewelBalance) }}</strong> {{ $t('jewelUnit') }}</div>
        </div>
        <div class="refresh-button">
          <enlil-button :block="true" :disabled="isFetching" @click="fetchCurrentUserInfo">
            <span v-if="isFetching"><loading-wheel/></span>
            <span v-else>{{ $t('requestExchange.reload') }}</span>
          </enlil-button>
        </div>
      </div>

      <div class="form-group">
        <p>{{ $t('requestExchange.inputAmountYouWantToExchange') }}</p>
        <div>
          <input class="amount-input" :class="{ 'has-error': isFormEditable && !isSufficient }" type="number" pattern="\d*" :min="requirementGTE" :max="requirementLTE" :step="requirementMultipleOf" v-model="formAmount" :disabled="!isFormEditable">
          <div class="error-message" v-if="isFormEditable">
            <p v-if="!isSufficientGTE" class="error">{{ $t('requestExchange.inputError.gte', { num: numberFormat(requirementGTE) }) }}</p>
            <p v-if="!isSufficientLTE" class="error">{{ $t('requestExchange.inputError.lte', { num: numberFormat(requirementLTE) }) }}</p>
            <p v-if="isSufficientGTE && isSufficientLTE && !isSufficientMultiple" class="error">{{ $t('requestExchange.inputError.multiple', { num: numberFormat(requirementMultipleOf), unit: $t('jewelUnit') }) }}</p>
          </div>
        </div>
      </div>

      <div class="action-group">
        <enlil-button :block="true" :disabled="!isFormEditable || !isSufficient" @click="onConfirmButtonClick">{{ $t('requestExchange.confirm') }}</enlil-button>
      </div>
    </panel>
  </section>
</template>

<style lang="scss" scoped>
.req-x-panel {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}
.loading {
  font-size: 0.8em;
  color: #999;
}
.error {
  font-size: 0.8em;
  color: #990000;
}
.balance {
  min-height: 3em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .refresh-button {
    font-size: 0.8em;
  }
}
.form-group {
  margin-bottom: 1em;
}
.action-group {
  margin-bottom: 0.5em;
}
.amount-input {
  text-align: right;
  display: block;
  width: 100%;
  box-sizing: border-box;
  border: 1px #ccc solid;
  border-radius: 3px;
  padding: 10px;

  &.has-error {
    border-color: #990000;
    box-shadow: 0 0 10px -4px #990000;
  }
}
</style>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import BackButton from '../../components/BackButton.vue'
import EnlilButton from '../../components/EnlilButton.vue'
import LoadingWheel from '../../components/LoadingWheel.vue'
import Panel from '../../components/Panel.vue'

export default {
  name: 'request-exchange',
  components: {
    BackButton,
    EnlilButton,
    LoadingWheel,
    Panel
  },
  computed: {
    ...mapGetters('requestForm', ['isSufficientLTE', 'isSufficientGTE', 'isSufficientMultiple', 'isSufficient', 'requirementLTE', 'requirementGTE', 'requirementMultipleOf']),
    ...mapState('currentUserInfo', ['isFetching', 'isFetched', 'isError', 'jewelBalance', 'isBelongingToAgency']),
    ...mapState('requestForm', ['requestUUID', 'requestAmount']),
    isFormEditable () { return !this.isFetching && !this.isError },
    formAmount: {
      get () {
        return this.requestAmount
      },
      set (newValue) {
        let value = null
        if (!newValue || newValue === '') {
          value = 0
        } else {
          value = parseInt(newValue)
        }

        this.setRequestAmount({ amount: value })
      }
    }
  },
  async mounted () {
    if (this.isBelongingToAgency) {
      this.$router.replace('/')
      return
    }

    if (!this.requestUUID) {
      this.initState()
    }

    if (!this.isFetched && !this.isFetching) {
      await this.fetchCurrentUserInfo()
    }
  },
  methods: {
    ...mapMutations('requestForm', ['setRequestAmount']),
    ...mapActions('currentUserInfo', { fetchCurrentUserInfo: 'fetch' }),
    ...mapActions('requestForm', { initState: 'init' }),
    onConfirmButtonClick () {
      this.$router.push('/request_exchange_confirm')
    },
    numberFormat (num) {
      return (num || 0).toLocaleString()
    }
  }
}
</script>
